export type JournalsAmendmentsStatus =
  | "NEW"
  | "SIGNING_CHANGES"
  | "PREPARING_XML"
  | "ON_SIGNING"
  | "REJECTED"
  | "PUBLISHED";

export type AmendmentAction =
  | "SAVE"
  | "SUBMIT"
  | "WITHDRAW"
  | "SIGN_CHANGES"
  | "XML_READY_WITH_SIGNERS"
  | "XML_READY_WITHOUT_SIGNERS"
  | "SIGN_AUTHORIZED"
  | "REJECT"
  | "RETURN_TO_WORK";

const AMENDMENT_TRANSITIONS: Record<
  JournalsAmendmentsStatus,
  Partial<Record<AmendmentAction, JournalsAmendmentsStatus>>
> = {
  NEW: {
    SAVE: "NEW",
    SUBMIT: "SIGNING_CHANGES",
  },
  SIGNING_CHANGES: {
    WITHDRAW: "NEW",
    SIGN_CHANGES: "PREPARING_XML",
    REJECT: "REJECTED",
  },
  PREPARING_XML: {
    XML_READY_WITH_SIGNERS: "ON_SIGNING",
    XML_READY_WITHOUT_SIGNERS: "PUBLISHED",
  },
  ON_SIGNING: {
    SIGN_AUTHORIZED: "PUBLISHED",
    REJECT: "REJECTED",
  },
  REJECTED: {
    RETURN_TO_WORK: "NEW",
  },
  PUBLISHED: {},
};

export const getNextAmendmentStatus = (
  status: JournalsAmendmentsStatus,
  action: AmendmentAction,
) => AMENDMENT_TRANSITIONS[status][action] ?? null;

export const canApplyAmendmentAction = (
  status: JournalsAmendmentsStatus,
  action: AmendmentAction,
) => getNextAmendmentStatus(status, action) !== null;

export const isActiveAmendmentStatus = (
  status: JournalsAmendmentsStatus,
) => status !== "PUBLISHED";
